import { usdcContractAddress } from "@talentir/shared/abis/erc-20";
import { tokenContractAddress } from "@talentir/shared/abis/erc-1155";
import { getErrorMessage } from "@talentir/shared/helpers";
import { useCallback, useState } from "react";
import { toast } from "sonner";
import { useConfig } from "wagmi";
import { useReservoirkitClient } from "../use-reservoirkit-client";
import { useWaitForTransactionToBeIndexed } from "../use-wait-for-transaction-to-be-indexed";
import { useGetReservoirWallet } from "./use-get-reservoir-wallet";
import { getTxHash } from "./utils";

export function useReservoirBuy(tokenId?: string) {
    const reservoirClient = useReservoirkitClient();
    const config = useConfig();
    const { waitForTransactionToBeIndexed } = useWaitForTransactionToBeIndexed();

    const reservoir = useGetReservoirWallet();

    const [isLoading, setIsLoading] = useState(false);

    const buyAsync = useCallback(
        async (quantity: bigint, costRaw: bigint) => {
            setIsLoading(true);

            if (reservoirClient == null || config == null || tokenId == null || reservoir == null) {
                return;
            }

            try {
                let txHash: string | undefined;
                await reservoirClient.actions.buyToken({
                    items: [
                        {
                            token: `${tokenContractAddress}:${tokenId}`,
                            quantity: Number(quantity),
                        },
                    ],
                    wallet: reservoir.wallet,
                    options: {
                        currency: usdcContractAddress,
                        // partial: true,
                        // forceRouter: true,
                    },
                    onProgress: (progress) => {
                        txHash = getTxHash(progress);
                    },
                    expectedPrice: {
                        [`${usdcContractAddress}`]: {
                            raw: costRaw,
                        },
                    },
                });

                if (txHash != null) {
                    await waitForTransactionToBeIndexed(txHash);
                }
            } catch (e) {
                // console.trace(e);
                toast.error("Error", { description: getErrorMessage(e) });
                throw e;
            } finally {
                setIsLoading(false);
            }
        },
        [config, reservoirClient, tokenId, waitForTransactionToBeIndexed, reservoir],
    );

    return { buyAsync, isLoading };
}
